var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vertical-menu"},[_c('simplebar',{style:({ height: _vm.height })},[_c('SideNav')],1)],1),(_vm.isMobile)?_c('div',{attrs:{"id":"mobile-backdrop"},on:{"click":_vm.toggleMenu}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }